module.exports = __webpack_public_path__ + "static/media/hr-line.4c85ed4c.svg";